import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Box, Button, Text } from '@rsos/components/capstone/base';
import {
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import { deleteAppUser } from '@rsos/sinatra';
import { notifySuccess, notifyError } from '@rsos/utils/toastUtils';
import { GENERIC_REQUEST_ERROR_MESSAGE } from '../../../constants/defaultErrorMessages';
import { Label, ButtonContainer } from './Modal.styles';

const DeleteUserModal = ({
  orgID,
  isOpened,
  application,
  toggleDeleteUserModal,
  arrayHelpers,
  values,
}) => {
  const dispatch = useDispatch();

  const confirmDelete = () => {
    const deletedIdx = [];
    values.users.forEach((user, idx) => {
      dispatch(deleteAppUser(orgID, application, user))
        .then(() => {
          notifySuccess('You have successfully deleted the selected user(s).');
          deletedIdx.push(idx);
        })
        .catch(action => {
          const errorMessage = action?.error?.message;
          notifyError(
            errorMessage ? errorMessage : GENERIC_REQUEST_ERROR_MESSAGE,
          );
        })
        .finally(() => {
          if (deletedIdx.length) {
            deletedIdx.forEach(idx => arrayHelpers.remove(idx));
          }
        });
      toggleDeleteUserModal();
    });
  };

  return (
    <Modal
      id="edit-user-modal"
      isOpened={isOpened}
      onClose={toggleDeleteUserModal}
      width={350}
    >
      <ModalHeader onClose={toggleDeleteUserModal}>
        <Box mx="5px">
          <Text size="xlarge" color="secondaryText">
            Delete User
          </Text>
        </Box>
      </ModalHeader>

      <ModalBody justify="center" noFooter>
        <Box mx="5px" pb={'27px'}>
          <Box>
            <Label>
              <Text size="small">
                Are you sure you want to delete the selected user(s)?
              </Text>
            </Label>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter justify="center">
        <ButtonContainer horizontal>
          <Button grow btnType="tertiary" onClick={toggleDeleteUserModal}>
            Cancel
          </Button>
          <Button grow btnType="primary" onClick={confirmDelete}>
            Confirm
          </Button>
        </ButtonContainer>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteUserModal;
